/**
 * Detect executing-bundle skew: the deployed build's `entryChunks` (from /version.json)
 * against the chunk the running code was loaded from (`import.meta.url` in the shell's
 * main.tsx). A mismatch means the browser served a stale cached subresource under a fresh
 * document — the failure mode document-meta version checks are blind to.
 *
 * `false` when either side is missing or empty (old manifests, unstamped local dev):
 * absence of evidence is never treated as skew.
 */
export function isEntryChunkSkewed(
    entryChunks: readonly string[] | undefined,
    executingUrl: string | undefined,
): boolean {
    if (!entryChunks?.length || !executingUrl) return false;
    const basename = executingUrl.split('#')[0].split('?')[0].split('/').pop();
    if (!basename?.endsWith('.js')) return false;
    return !entryChunks.includes(basename);
}
